// extracted by mini-css-extract-plugin
export var downArrow = "_97-0";
export var label = "_97-1";
export var treatmentCard = "_97-3";
export var upArrow = "_97-2";